import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HEADER_OFFSET = 96; // fixed navbar (h-20 = 80px) + wat ademruimte

// Scrollt bij elke navigatie naar het begin van de content, of naar het
// juiste anker met correcte offset voor de vaste header.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wacht tot de nieuwe pagina gerenderd is, zoek dan het anker
      const id = decodeURIComponent(hash.replace("#", ""));
      let tries = 0;
      const scrollToAnchor = () => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else if (tries < 10) {
          tries += 1;
          setTimeout(scrollToAnchor, 60);
        }
      };
      scrollToAnchor();
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
